import { render, staticRenderFns } from "./Own.vue?vue&type=template&id=d8199104&"
import script from "./Own.vue?vue&type=script&lang=js&"
export * from "./Own.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports